"use client";

import { CheckIcon, GlobeIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { FlagComponent } from "@/components/form/phone-input";
import {
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuSub,
	DropdownMenuSubContent,
	DropdownMenuSubTrigger,
} from "@/components/ui/dropdown-menu";
import { useLangChange } from "@/hooks/use-lang-change";
import { languages } from "@/i18n";
import { getLocaleCountry } from "@/lib/utils";

export function ProfileDropdownLanguage() {
	const { t } = useTranslation();
	const { currentLocale, setLang } = useLangChange();

	return (
		<DropdownMenuSub>
			<DropdownMenuSubTrigger className="w-full">
				<GlobeIcon className="mr-2 size-4" />
				<span>
					{t(($) => $.common.components.profileDropdown.items.language)} ({getLocaleCountry(currentLocale).countryName})
				</span>
			</DropdownMenuSubTrigger>
			<DropdownMenuSubContent className="w-48">
				<DropdownMenuGroup>
					{languages.map((lang) => {
						const { country, countryName } = getLocaleCountry(lang);
						return (
							<DropdownMenuItem className="cursor-pointer justify-between" key={lang} onClick={() => setLang(lang)}>
								<div className="flex items-center gap-2">
									<div className="[&_svg]:w-4">
										<FlagComponent country={country} countryName={countryName} />
									</div>
									<span>{countryName}</span>
								</div>

								<CheckIcon aria-hidden={lang !== currentLocale} className="size-4 aria-hidden:hidden" />
							</DropdownMenuItem>
						);
					})}
				</DropdownMenuGroup>
			</DropdownMenuSubContent>
		</DropdownMenuSub>
	);
}
